import * as React from 'react';
import withStyles from 'react-jss';
import { StylesProps } from 'src/Library/Types';
import { useGenericState } from 'src/Library/UseGenericState';
import moment from 'moment';
import { VesselTrackingObject } from './VesselTracking.interface';
import { tokens } from 'src/design-system';
import ShipFilled from 'src/components/common/icons/ShipFilled';
const { useEffect } = React;
const styles = (theme) => ({
  line: {
    height: '0',
    display: 'flex',
    flex: '1',
  },
  verticalLine: {
    width: 0,
    height: 35,
    //display: 'flex',
    //flexDirection: 'column',
    //flex: '1',
    marginLeft: 3,
    marginTop: '3px',
    marginBottom: '3px',
  },
  fetchingData: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '45px',
  },
  dot: {
    height: 6,
    width: 6,
    borderRadius: '50%',
    display: 'inline-block',
  },
  nodeDiv: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'space-between',
  },
  nodeTextDiv: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  trackingContent: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    // paddingLeft: '10px',
    // paddingRight: '30px',
  },
  nodeTitle: {
    fontSize: tokens.fontSize.small,
    color: tokens.colors.textSecondary,
    fontWeight: 550,
  },
  dateAndTime: {
    fontSize: tokens.fontSize.small,
    color: tokens.colors.textTertiary,
    opacity: 0.6,
    marginTop: '1%',
  },
  station: {
    fontSize: tokens.fontSize.small,
    // lineHeight: 13,
    color: tokens.colors.primary,
    fontWeight: 550,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 75,
  },
  trackingUnavailableDiv: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  unavailableText: {
    marginTop: tokens.spacing.ms,
    display: 'flex',
    flexDirection: 'row',
    color: tokens.colors.text,
    fontSize: tokens.fontSize.small,
    opacity: 0.7,
  },
});
interface iProps extends StylesProps<ReturnType<typeof styles>> {
  tracking: VesselTrackingObject[];
  currentVessel: boolean;
  setCurrentLeg: (currentLeg: VesselTrackingObject) => void;
}
interface TrackingNode {
  nodeTitle?: React.ReactElement;
  dateAndTime?: string;
  color?: string;
  nextLineColor?: string;
  station?: string;
  tooltipObject?: {};
  lineType?: string;
  nextLineType?: string;
  isShip?: boolean;
  midJourney?: boolean;
}
interface StateProps {
  legs: number;
  nodes?: TrackingNode[];
}
const VesselTracking = (props: iProps) => {
  const { classes, tracking, currentVessel, setCurrentLeg } = props;
  enum colors {
    green = '#55B940',
    grey = '#999999',
  };
  const [state, setState] = useGenericState<StateProps>({
    legs: 1,
  });
  const { legs, nodes } = state;
  const getNodeTitle = (portName, flagUrl) => {
    return <div style={{ display: 'flex', alignItems: 'center' }}>
      <img style={{ width: 15, height: 9, marginRight: 5 }} src={flagUrl}/>
      <span className={classes.nodeTitle}>
          {portName || '-'}
      </span>
    </div>
  }
  const setTrackingNodes = () => {
    let nodes: TrackingNode[] = [];
    const reverseTracking = tracking?.slice()?.reverse();
    let shipSet = false;
    reverseTracking?.forEach((leg, index) => {
      let trackingNode: TrackingNode = {};
      let trackingNode2: TrackingNode = {};
      if (shipSet) {
        trackingNode.color = colors.green;
        trackingNode.nextLineColor = colors.green;
        trackingNode.lineType = 'solid';
        trackingNode.nextLineType = 'solid';
        trackingNode.dateAndTime = leg.atd ? `${moment(leg.atd).format('DD MMM | HH:mm')} hrs` : '-';
        trackingNode.nodeTitle = getNodeTitle(leg.departurePortName, leg.departurePortCountryFlag);
        trackingNode.station = leg.departurePort || '-';
      } else if (leg?.ata) {
        trackingNode.color = colors.green;
        trackingNode.nextLineColor = colors.green;
        trackingNode.lineType = 'solid';
        trackingNode.nextLineType = 'solid';
        trackingNode.dateAndTime = leg.ata ? `${moment(leg.ata).format('DD MMM | HH:mm')} hrs` : '-';
        trackingNode.nodeTitle = getNodeTitle(leg.arrivalPortName, leg.arrivalPortCountryFlag);
        trackingNode.station = leg.arrivalPort || '-';
        trackingNode.isShip = true;
        currentVessel && setCurrentLeg(leg);
        shipSet = true;
        trackingNode2.color = colors.green;
        trackingNode2.nextLineColor = colors.green;
        trackingNode2.lineType = 'solid';
        trackingNode2.nextLineType = 'solid';
        trackingNode2.dateAndTime = leg.atd ? `${moment(leg.atd).format('DD MMM | HH:mm')} hrs` : '-';
        trackingNode2.nodeTitle = getNodeTitle(leg.departurePortName, leg.departurePortCountryFlag);
        trackingNode2.station = leg.departurePort || '-';
      } else if (!leg?.ata) {
        trackingNode.color = colors.grey;
        trackingNode.nextLineColor = colors.grey;
        trackingNode.lineType = 'dotted';
        trackingNode.nextLineType = 'dotted';
        trackingNode.dateAndTime = leg.eta ? `${moment(leg.eta).format('DD MMM | HH:mm')} hrs` : '-';
        trackingNode.nodeTitle = getNodeTitle(leg.arrivalPortName, leg.arrivalPortCountryFlag);
        trackingNode.station = leg.arrivalPort || '-';
        if (leg?.atd) {
          trackingNode2.color = colors.green;
          trackingNode2.nextLineColor = colors.green;
          trackingNode2.lineType = 'solid';
          trackingNode2.nextLineType = 'solid';
          trackingNode2.dateAndTime = leg.atd ? `${moment(leg.atd).format('DD MMM | HH:mm')} hrs` : '-';
          trackingNode2.nodeTitle = getNodeTitle(leg.departurePortName, leg.departurePortCountryFlag);
          trackingNode2.station = leg.departurePort || '-';
          trackingNode2.isShip = true;
          currentVessel && setCurrentLeg(leg);
          trackingNode2.midJourney = true;
          shipSet = true;
        }
      }
      nodes.push(trackingNode);
      if (index === tracking.length - 1 && !shipSet && !Object.keys(trackingNode2).length) {
        trackingNode2.nextLineColor = undefined;
        trackingNode2.nextLineType = undefined;
        trackingNode2.nodeTitle = getNodeTitle(leg.departurePortName, leg.departurePortCountryFlag);
        trackingNode2.station = leg.departurePort || '-';
        trackingNode2.color = colors.grey;
        trackingNode2.lineType = 'dotted';
        trackingNode2.dateAndTime = leg.etd ? `${moment(leg.etd).format('DD MMM | HH:mm')} hrs` : '-';
        trackingNode2.isShip = true;
        currentVessel && setCurrentLeg(leg);
      }
      Object.keys(trackingNode2).length && nodes.push(trackingNode2);
    });
    setState({ nodes });
  }
  useEffect(() => {
    setTrackingNodes();
  }, []);
  const renderLine = (color, type, key?) => {
    return <span
      key={key}
      className={classes.line}
      style={{  borderTop: `1px ${type} ${color}` }}
    />;
  };
  const renderNodeTitleDateAndTime = (title, dateAndTime) => {
    return <div className={classes.nodeTextDiv}>
      <span className={classes.nodeTitle}>{title}</span>
      <span className={classes.dateAndTime}>{dateAndTime}</span>
    </div>
  }
  const renderDot = (color) => {
    return <span className={classes.dot} style={{ backgroundColor: color }} />;
  }
  const renderNodeStation = (station, index) => {
    return <span 
    className={classes.station}>
      {station}
    </span>;
  }
  const renderTrackingHelperForTitle = () => {
    const newArr: any[] = [];
    if (!nodes) return;
    for (let i = 0; i < nodes?.length; i += 1) {
      newArr.push(renderNodeTitleDateAndTime(nodes[i].nodeTitle, nodes[i].dateAndTime));
    }
    return newArr.reverse();
  }
  const renderTrackingHelperForLine = () => {
    const newArr: any[] = [];
    if (!nodes) return;
    for (let i = 0; i < nodes?.length; i += 1) {
      if (nodes[i].isShip && nodes[i].midJourney) {
        newArr.push(<ShipFilled
          height={'18px'}
          width={'27px'}
          color={colors.green}
        />);
      }
      newArr.push(i !== 0 && renderLine(nodes[i].color, nodes[i].lineType, `line-${2*i}`))
      if (nodes[i].isShip && !nodes[i].midJourney) {
        newArr.push(<ShipFilled
            height={'18px'}
            width={'27px'}
            color={colors.green}
          />)
      } else {
        newArr.push(renderDot(nodes[i].color));
      }
      i < nodes?.length - 1 && newArr.push(nodes[i].nextLineType && renderLine(nodes[i].nextLineColor, nodes[i].nextLineType, `line-${2*i+1}`));
    }
    return newArr.reverse();
  }
  const renderTrackingHelperForStation = () => {
    const newArr: any[] = [];
    if (!nodes) return;
    for (let i = 0; i < nodes?.length; i += 1) {
      newArr.push(renderNodeStation(nodes[i].station, i));
    }
    return newArr.reverse();
  }
  const renderTracking = () => {
    return <div className={classes.nodeDiv}>
      <div className={classes.trackingContent}>
        {renderTrackingHelperForTitle()}
      </div>
      <div className={classes.trackingContent} style={{ marginRight: '5%', marginLeft: '4%', marginTop: '1%', marginBottom: '1%' }}>
        {renderTrackingHelperForLine()}
      </div>
      <div className={classes.trackingContent}>
        {renderTrackingHelperForStation()}
      </div>
    </div>
  }
  return renderTracking();
};

export default withStyles(styles)(VesselTracking);